export default __webpack_public_path__ + "static/media/FONDO_MAIZ.6827803f.jpg";